'use client';

/**
 * Liten signalkanal mellan axios-interceptorn (utanför React) och rapportdialogen (i React).
 * Interceptorn kan inte anropa en hook, så den ropar hit och Felfångare lyssnar.
 */

type Lyssnare = () => void;

const lyssnare = new Set<Lyssnare>();

export function begärRapportdialog(): void {
  lyssnare.forEach((l) => l());
}

export function lyssnaPåRapportbegäran(l: Lyssnare): () => void {
  lyssnare.add(l);
  return () => {
    lyssnare.delete(l);
  };
}
